import type { KpiFormMetricFormValue } from '@salescore/client-redux'
import { getMetricFromKpiFormula, type ViewConfigKpi } from '@salescore/core'

import type { KpiForm } from '../atoms'
import { parseKpiFormulaWithMetric } from '../attachMetricToKpiConfig'

// 他に適切な置き場所があるかも。。。
export function generateInitialKpiForm({ viewName, config }: { viewName: string; config: ViewConfigKpi }): KpiForm {
  const rest = {
    type: config.type,
    formula: config.formula,
    ui: config.ui,
    presets: config.presets,
    sheetExtraSetting: config.sheetExtraSetting,
    options: config.options,
  }
  const metric = getMetricFromKpiFormula(parseKpiFormulaWithMetric(config.formula))
  const metricFormValue: KpiFormMetricFormValue = {
    sheet: metric?.sheet,
    measure: metric?.measure,
    date: metric?.date,
    user: metric?.user,
  }
  return {
    ...rest,
    metricFormValue,
    name: viewName,
    // eslint-disable-next-line sonarjs/todo-tag
    dashboardIds: [], // TODO
  }
}
